import { createFileRoute, Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { ProductCard } from "@/components/ProductCard";
import { getMyWishlist } from "@/lib/wishlist.functions";

export const Route = createFileRoute("/_authenticated/zelje")({
  head: () => ({ meta: [{ title: "Seznam želja — kupish.si" }] }),
  component: Page,
});

function Page() {
  const fetchWishlist = useServerFn(getMyWishlist);
  const { data, isLoading } = useQuery({ queryKey: ["my-wishlist"], queryFn: () => fetchWishlist() });

  return (
    <section className="mx-auto max-w-7xl px-6 py-16">
      <Link to="/dashboard" className="text-xs eyebrow hover:text-accent">← Nadzorna plošča</Link>
      <h1 className="font-serif text-4xl md:text-5xl mt-3">Seznam želja</h1>

      {isLoading ? (
        <div className="mt-12 text-muted-foreground">Nalagam…</div>
      ) : !data || data.products.length === 0 ? (
        <div className="mt-12 border border-dashed border-border p-12 text-center">
          <p className="text-muted-foreground">Vaš seznam želja je prazen.</p>
          <Link to="/izdelki" className="mt-4 inline-block underline underline-offset-4">Razišči izdelke →</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12 mt-10">
          {data.products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </section>
  );
}
